import React, { useContext, useEffect, useRef, useState } from 'react'
import Card from '../../../../Base/Components/Card/Card'
import { Button } from 'primereact/button'
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';
import Loader from '../../../../Base/Components/Loader/Loader';
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';
import { setTitlePage } from '../../../../Base/Services/Config/ConfigService';
import { getRequisasPendientesAprobarFinanzas, getRequisasPendientesAprobarPlantManager, putPermiso1, putPermiso3 } from '../../../../API/Compras/Requisas/PurchareDetailsRequests';
import { checkBoxTemplate } from '../../../../Base/Services/TemplatesServices';
import DialogPassword from '../../../../Base/Components/Dialog/DialogPassword/DialogPassword';
import { getDateTimeStringSQL } from '../../../../Base/Services/Moment/Luxon';
import { AccesoUser, authByUserOrRol } from '../../../../API/IT/Accesos/AccesosRequests';
import { toastShow } from '../../../../Base/Services/ToastService';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import RequisicionComprasModalCURD from '../CrudRequisa/RequisaComprasModalCrud';

import { InputSwitch } from 'primereact/inputswitch';

const AprobarRequisasScreen = () => {

    const toast = useRef(null);
    const tableRef = useRef(null);
    const { userAuth } = useContext(AuthContext);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [dates, setDates] = useState([new Date(), new Date()]);
    const [selected, setSelected] = useState([]);
    const [rowEdit, setRowEdit] = useState(null);
    const [showDialog, setShowDialog] = useState(false);
    const [display, setDisplay] = useState(false);
    const [password, setPassword] = useState('');
    const [permiso, setPermiso] = useState(null);

    const [user, setUser] = useState(null);

    const getInfo = async () => {
        setLoading(true);
        if (user === 'luise') {
            const t = await getRequisasPendientesAprobarPlantManager();
            setData(t)
        }
        if (user === 'imatamoros') {
            const t = await getRequisasPendientesAprobarFinanzas();
            setData(t)
        }
        setLoading(false);
    }

    const changeEstado = (row) => {

        if (row.Permiso1 || row.Permiso3) {
            row.EstadoPD = "En Firma";
            row.IdEstado = 172;
        } else {
            if (!row.Permiso3 && !row.Permiso1) {
                if (!row.ConPrecio) {
                    if (row.RequestType === 'Regalia') {
                        row.EstadoPD = "Cotizado";
                        row.IdEstado = 3334;
                    } else {
                        row.EstadoPD = "Solicitado";
                        row.IdEstado = 3326;
                    }
                } else {
                    row.EstadoPD = "Cotizado";
                    row.IdEstado = 3334;
                }
            }
        }
        if (row.Permiso1 && row.Permiso3) {
            row.IdEstado = 3328;
            row.EstadoPD = "Aprobado";
        }
        return row;
    };

    const authPermiso = async () => {
        setLoading(true);
        const promesa = await AccesoUser({
            Usuario: userAuth.Usuario,
            Password: password,
            window: permiso === 1 ? 'IsisMatamoros' : 'Waheed'
        })
        verificarRespuesta(promesa);
    };

    const authByUser = async () => {
        setLoading(true);
        const promesa = await authByUserOrRol({
            form: "Acceso Maestro",
            Rol: userAuth.Rol,
            User1: userAuth.Usuario,
        })
        verificarRespuesta(promesa);
    };

    const verificarRespuesta = (res) => {
        console.log(selected.length);
        if (res[0].Acceso === 1) {
            if (selected.length > 0) {
                selected.forEach((rowEdit) => {
                    if (rowEdit.IdEstado !== 3518) {
                        if (rowEdit.IdEstado !== 3333) {
                            if (rowEdit.IdEstado !== 3328) {
                                if ((rowEdit.ConPrecio && rowEdit.Price > 0) || rowEdit.RequestType === 'Regalia') {
                                    changePermiso(rowEdit, permiso);
                                } else {
                                    toastShow(
                                        toast,
                                        "error",
                                        "Producto sin precio",
                                        `El producto ${rowEdit.NombreProducto} no tiene precio.`
                                    );
                                }
                            } else {
                                toastShow(
                                    toast,
                                    "error",
                                    "No se puede aprobar",
                                    `El producto ${rowEdit.NombreProducto} ya se encuentra aprobado, no se puede modificar.`
                                );
                            }
                        } else {
                            toastShow(
                                toast,
                                "error",
                                "No se puede aprobar",
                                `El producto ${rowEdit.NombreProducto} ya se encuentra en Orden de Compra.`
                            );
                        }
                    } else {
                        toastShow(
                            toast,
                            "error",
                            "No se puede aprobar",
                            `El producto ${rowEdit.NombreProducto} necesita autorización de gerente de área.`
                        );
                    }
                });
            } else {
                toastShow(toast, 'warning', 'Advertencia', 'Debe seleccionar un registro')
            }
        } else {
            toastShow(toast, 'error', 'Error', 'Contraseña incorrecta')
        }
        setDisplay(false);
        setSelected([]);
        setPassword('');
        onHide();
        setLoading(false);
    }

    const changePermiso = (rowEdit, permiso) => {
        console.log('change permiso', rowEdit, permiso);
        let tempo = data;
        const index = tempo.findIndex(
            (detail) =>
                detail.IdPurcharesRequestDetail === rowEdit.IdPurcharesRequestDetail
        );
        switch (permiso) {
            case 1:
                tempo[index].Permiso1 = !rowEdit.Permiso1;
                tempo[index].FechaPermiso1 =
                    rowEdit.Permiso1 === true ? getDateTimeStringSQL(new Date()) : null;
                tempo[index] = changeEstado(tempo[index]);
                putPermiso1(
                    tempo[index].IdPurcharesRequestDetail,
                    tempo[index].Permiso1,
                    tempo[index].FechaPermiso1,
                    tempo[index].UsuarioPermiso1,
                    tempo[index].IdEstado
                );
                break;
            case 3:
                tempo[index].Permiso3 = !rowEdit.Permiso3;
                tempo[index].FechaPermiso3 =
                    rowEdit.Permiso3 === true ? getDateTimeStringSQL(new Date()) : null;
                tempo[index] = changeEstado(tempo[index]);
                putPermiso3(
                    tempo[index].IdPurcharesRequestDetail,
                    tempo[index].Permiso3,
                    tempo[index].FechaPermiso3,
                    tempo[index].UsuarioPermiso3,
                    tempo[index].IdEstado
                );
                break;

            default:
                break;
        }
    };


    const columns = [
        {
            // EstadoPD
            field: "EstadoPD",
            header: "Estado",
            className: "Xsmall",
            body: rowData => ({ ID: rowData.IdEstado, Estado: rowData.EstadoPD }),
            frozen: "frozen",
            Format: 'Estado',
        },
        {
            // PurchaseRequest
            field: "PurchaseRequest",
            header: "No. Requisa",
            className: "small",
            frozen: "frozen",
            Format: 'Modal',
        },
        // {
        //     // SalesOrder
        //     field: "SalesOrder",
        //     header: "SalesOrder",
        //     className: "small",
        // },
        {
            // FechaPermiso4
            field: "FechaPermiso4",
            header: "Fecha Liberada",
            className: "medium",
            Format: 'DateTime',
        },
        {
            // Proveedor
            field: "Proveedor",
            header: "Proveedor",
            className: "Xlarge",
        },
        {
            // NombreProducto
            field: "NombreProducto",
            header: "Producto",
            className: "Xlarge",
            Sumary: 'count',
        },
        {
            // UnitSimbol
            field: "UnitSimbol",
            header: "Unidad",
            className: "Xsmall",
            Format: 'Center',
        },
        {
            // Quantity
            field: "Inventario",
            header: "Invetario",
            className: "small",
            Sumary: 'sum',
            Format: 'Currency',
        },
        {
            // Quantity
            field: "Quantity",
            header: "Cantidad",
            className: "small",
            Sumary: 'sum',
            Format: 'Currency',
        },
        {
            // Price
            field: "Price",
            header: "Precio",
            className: "small",
            Format: 'Currency',
        },
        {
            // ISV
            field: "ISV",
            header: "ISV",
            className: "small",
            Format: 'Currency',
        },
        {
            // Descuento
            field: "Descuento",
            header: "Descuento",
            className: "small",
            Format: 'Currency',
        },
        {
            // SubTotal
            field: "SubTotal",
            header: "SubTotal",
            className: "small",
            Sumary: 'sum',
            Format: 'Currency',
        },
        {
            // Total
            field: "Total",
            header: "Total",
            className: "small",
            Sumary: 'sum',
            Format: 'Currency',
        },
        {
            // CurrencySymbol
            field: "CurrencySymbol",
            header: "Moneda",
            className: "small",
            Format: 'Center',
        },
        {
            // Comment
            field: "Comment",
            header: "Comentarios",
            className: "XXlarge",
            body: (rowData) => rowData.Comment,
        },
        {
            // Description
            field: "Description",
            header: "Decripción",
            className: "XXlarge",
            body: (rowData) => rowData.Description,
        },
        {
            // RequestType
            field: "RequestType",
            header: "Tipo Requisa",
            className: "small",
            body: (rowData) => rowData.RequestType,
        },
        {
            // Priority
            field: "Priority",
            header: "Prioridad",
            className: "Xsmall",
            body: (rowData) => ({ ID: rowData.Priority, Estado: rowData.Priority }),
            Format: 'Estado',
        },
        {
            // AgentName
            field: "AgentName",
            header: "Asignado a",
            className: "large",
        },
        {
            // Area
            field: "Area",
            header: "Área",
            className: "medium",
        },
        {
            // DateCreated
            field: "DateCreated",
            header: "Fecha Creada",
            className: "large",
            Format: 'DateTime',
        },
        {
            // Dias
            field: "Dias",
            header: "Dias",
            className: "Xsmall",
            Format: 'Dias'
        },

        {
            // CodigoProducto
            field: "CodigoProducto",
            header: "Codigo Producto",
            className: "small",
        },
        {
            // TipoSuministro
            field: "NombreTipo",
            header: "Tipo",
            className: "small",
        },
        {
            // EstadoPR
            field: "EstadoPR",
            header: "Estado General",
            className: "Xsmall",
            body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.EstadoPR }),
            Format: 'Estado',

        },

        {
            // TotalL
            field: "TotalL",
            header: "Lempiras",
            className: "small",
            Sumary: 'sum',
            Format: 'Currency',
        },
        {
            // TotalD
            field: "TotalD",
            header: "Dolares",
            className: "small",
            Sumary: 'sum',
            Format: 'Currency',
        },
        {
            // TotalE
            field: "TotalE",
            header: "Euros",
            className: "small",
            Sumary: 'sum',
            Format: 'Currency',
        },
        {
            // ASolicita
            field: "ASolicita",
            header: "Solicita",
            className: "large",
        },
        {
            // NombreCategoria
            field: "NombreCategoria",
            header: "Categoria",
            className: "large",
        },
        {
            // FechaPermiso1
            field: "FechaPermiso1",
            header: "Fecha Finanzas",
            className: "large",
            Format: 'DateTime',
        },
        {
            // FechaPermiso3
            field: "FechaPermiso3",
            header: "Fecha  P. Manager",
            className: "large",
            Format: 'DateTime',
        },
        {
            // FechaCotizacion
            field: "FechaCotizacion",
            header: "Fecha  precio",
            className: "large",
            Format: 'DateTime',
        },
        {
            // UsuarioPermiso4
            field: "UsuarioPermiso4",
            header: "Gerente Area",
            className: "Xsmall",
        },
        {
            // UsuarioPermiso4
            field: "UsuarioPermiso",
            header: "Usuario Auth",
            className: "Xsmall",
            body: (rowData) => checkBoxTemplate({ value: rowData.UsuarioPermiso4 != null }),
            Format: 'Template'
        },
        {
            // ConPrecio
            field: "ConPrecio",
            header: "ConPrecio",
            className: "Xsmall",
            Format: 'Checkbox'
            // body: (rowData) => checkBoxTemplate({value: rowData?.ConPrecio}),
            // Format: 'Template',
        },
        {
            // Permiso1
            field: "Permiso1",
            header: "Finanzas",
            className: "Xsmall",
            Format: 'Checkbox',
            disabled: userAuth !== 'luise',
            onChange: (e, rowData) => {
                if (selected.length === 0) {
                    setSelected([rowData.data]);
                }
                setDisplay(true);
                setRowEdit(rowData);
                setPermiso(1);
            },
            frozen: "frozen",
            alignFrozen: "right",

        },
        {
            // Permiso3
            field: "Permiso3",
            header: "Plant Manager",
            className: "Xsmall",
            Format: 'Checkbox',
            disabled: userAuth !== 'imatamoros',
            onChange: (e, rowData) => {
                if (selected.length === 0) {
                    setSelected([rowData.data]);
                }
                setDisplay(true);
                setRowEdit(rowData);
                setPermiso(3);
            },
            frozen: "frozen",
            alignFrozen: "right",
        },
    ];

    const onHide = () => {
        setDisplay(false);
        setPassword('');
        setRowEdit(null);
        setPermiso(null);
        setSelected([]);
        setShowDialog(false);
    }

    const table = {
        Columns: columns,
        Data: data,
        Loading: loading,
        selected: selected,
        setSelected: setSelected,
        showModal: e => showModal(e),
    };

    const showModal = (purchaseRequest) => {
        setRowEdit(purchaseRequest);
        setShowDialog(true);
    }


    useEffect(() => {
        setUser(userAuth.Usuario);
        setTitlePage('Aprobar Requisas');
    }, [])

    useEffect(() => {
        if (user) {
            getInfo();
        }
        console.log({user});
        if(user !== 'imatamoros' && user !== 'luise'){
            setUser('imatamoros');
        }
    }, [user])


    return (
        <div>
            <Loader loading={loading} />
            <Toast ref={toast} />
            <Card
                titulo={<div className='botones'>
                    <h3>Aprobar Requisas</h3>
                    <Button icon='pi pi-search' onClick={getInfo} />
                    {userAuth.IdRol === 1 && <div className='d-flex gap' style={{ alignItems: 'center', gap: 10}}>
                        <label className='mr-2'>Plant Manager Filter</label>
                        <InputSwitch
                            checked={user === 'luise'}
                            onChange={(e) => setUser(e.value ? 'luise' : 'imatamoros')}
                        />
                        <label className='mr-2'>Accounting Filter</label>
                    </div>}
                </div>}
                contenido={<div className='pt-3' style={{ height: '90vh' }}>
                    <AgGrid table={table} />
                </div>}
            />
            <DialogPassword
                display={display}
                setDisplay={setDisplay}
                password={password}
                setPassword={setPassword}
                authByUserOrRol={authByUser}
                authPermiso={authPermiso}
                loading={loading}
                onHide={onHide}
                showInput={true}
                selected={selected}
            />
            <Dialog visible={showDialog} onHide={onHide} maximizable closeOnEscape={false} maximized >
                <RequisicionComprasModalCURD idRequisa={rowEdit} showDialog={showDialog} />
            </Dialog>
        </div>
    )
}

export default AprobarRequisasScreen